
import React, { useEffect, useMemo, useState } from 'react'
import styles from '../../styles/modules/Dashboard.module.css'
import DashboardDataCard from './DashboardDataCard';
import { MdGroups, MdOutlineEventNote, MdOutlineTimelapse } from "react-icons/md";
import { CoachSchedulerAPI } from '../../api/CoachSchedulerAPI';
import { useSelector } from 'react-redux';
import RSVPCard from './RSVPCard';
import { useDispatch } from 'react-redux';
import { rootAction } from '../../redux/reducer/rootReducer';
import Loader from '../../component/Loader'
import { CalendarAPI } from '../../api/CalendarAPI';
import RevenueLineChart from './RevenueLineChart';
import PieChart from '../Charts/PieChart';
import PolarAreaChart from '../Charts/PolarAreaChart';
import { ReportingAPI } from '../../api/Reporting';
import { EventAPI } from '../../api/EventAPI';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import ScheduleCard from './ScheduleCard';
import { CgDollar } from 'react-icons/cg';
import { isClubOwner, isClubStaff } from '../../util/UserRoles'
import { PrivilegeAPI } from '../../api/PrivilegesAPI';
import { Privileges } from '../../util/PrivilegeConstants';
import DashboardDataCard2 from './DashboardDataCard2';
import BarChart from './BarChart';
import EventFeeBarChart from './EventFeeBarChart';

const monthLabel = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];


const Dashboard = () => {
  document.title = "Dashboard"
  const userInfo = useSelector((store) => store.user.userInfo);
  const selectedClub = useSelector((store) => store.user.selectedClub);
  const dispatch = useDispatch();
  const [rsvpRequests, setRsvpRequests] = useState([]);
  const [isRSVPEnable, setIsRSVPEnable] = useState(false);
  const [isLOading, setIsLoading] = useState(false)
  const [isRefresh, setIsRefresh] = useState(false);
  const [eventList, setEventList] = useState([]);
  const [countingData, setCountingData] = useState({
    totalPlayer: {},
    totalMember: {},
    totalRevenue: {},
    pendingRevenue: {},
    totalEvent: {}
  })
  const [privileges, setPrivileges] = useState({});
  const [chartData, setChartData] = useState({
    totalRevenueSplitByMonth: [],
    eventTotalPlayer: [],
    totalPendingApprovedPlayer: [],
    totalTypeOfParticipantFee: {},
    totalPlayerByFee: []
  })
  const [scheduleData, setScheduleData] = useState({
    upcoming: [],
    past: []
  });
  const [selectedEvent, setSelectedEvent] = useState({
    event1: '',
    event2: '',
    event3: ''
  });
  const [loadingState, setLoadingState] = useState({
    loading1: false,
    loading2: false
  })

  const startLoading = (key) => {
    setLoadingState(prev => ({ ...prev, [key]: true }))
  };

  const finishLoading = (key) => {
    setLoadingState(prev => ({ ...prev, [key]: false }));
  };

  let isShowTransactionData = useMemo(() => (isClubOwner(userInfo) || (isClubStaff(userInfo) && privileges?.MANAGE_TRANSACTION?.includes(Privileges.VIEW))), [privileges, userInfo.userId])
  const fetchAllRSVPRequests = async () => {
    try {
      setIsLoading(true)
      const response = await CoachSchedulerAPI.findAllUserRSVPRequests(userInfo.userId, selectedClub.clubId);
      setRsvpRequests(response.Data);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  const findTotalPlayerFromClub = async () => {
    try {
      const response = await ReportingAPI.getTotalPlayerFromClub(selectedClub.clubId);
      setCountingData(prev => ({ ...prev, totalPlayer: response.Data }));
    } catch (error) {
      console.log(error);
    }
  };
  const findTotalPlayerFollowedByEvent = async () => {
    try {
      const response = await ReportingAPI.getTotalPlayerFollowedByEvent(selectedClub.clubId);
      setChartData(prev => ({ ...prev, eventTotalPlayer: response.Data }));
    } catch (error) {
      console.log(error);
    }
  };
  const findTotalMemberFromClub = async () => {
    try {
      const response = await ReportingAPI.getTotalMemberFromClub(selectedClub.clubId);
      setCountingData(prev => ({ ...prev, totalMember: response.Data }));
    } catch (error) {
      console.log(error);
    }
  };
  const findTotalRevenueFromClub = async (resPrivilige) => {
    try {
      startLoading("loading2")
      if (isClubOwner(userInfo) || (isClubStaff(userInfo) && resPrivilige?.MANAGE_TRANSACTION?.includes(Privileges.VIEW))) {
        const response = await ReportingAPI.getTotalSucceedRevenueFollowedByLastMonth(selectedClub.clubId);
        const response2 = await ReportingAPI.getTotalPendingRevenueFollowedByLastMonth(selectedClub.clubId);
        // console.log("RESPONSE", response);
        setCountingData(prev => ({ ...prev, totalRevenue: response.Data, pendingRevenue: response2.Data }));
      } else {
        const response = await ReportingAPI.getTotalMoneySpentByUserFollowedByLastMonth(selectedClub.clubId, userInfo.userId);
        setCountingData(prev => ({ ...prev, totalRevenue: response.Data }));
      }
    } catch (error) {
      console.log(error);
    } finally {
      startLoading("loading2")
    }
  };

  const findTotalEventFromClub = async () => {
    try {
      if (isClubOwner(userInfo) || isClubStaff(userInfo)) {
        const response = await ReportingAPI.getTotalEventFromClub(selectedClub.clubId);
        setCountingData(prev => ({ ...prev, totalEvent: response.Data }));
      } else {
        const response = await ReportingAPI.getTotalJoinedEventFromClub(selectedClub.clubId, userInfo.userId);
        setCountingData(prev => ({ ...prev, totalEvent: { prev: 0, curr: response.Data } }));
      }

    } catch (error) {
      console.log(error);
    }
  };
  const findTotalRevenueSplitByMonth = async (resPrivilige) => {
    try {
      startLoading("loading1");
      if (isClubOwner(userInfo) || (isClubStaff(userInfo) && resPrivilige?.MANAGE_TRANSACTION?.includes(Privileges.VIEW))) {
        const response = await ReportingAPI.getTotalRevenueSplitByMonth(selectedClub.clubId);
        setChartData(prev => ({ ...prev, totalRevenueSplitByMonth: response.Data }));
      } else {
        const response = await ReportingAPI.getTotalRevenueSplitByMonthByUser(selectedClub.clubId, userInfo.userId);
        setChartData(prev => ({ ...prev, totalRevenueSplitByMonth: response.Data }));
      }
    } catch (error) {
      console.log(error);
    } finally {
      finishLoading("loading1")
    }
  };
  const findTotalPendingAndApprovedPlayer = async () => {
    try {
      const response = await ReportingAPI.getTotalPendingAndApprovedPlayer(selectedEvent.event1, selectedClub.clubId);
      setChartData(prev => ({ ...prev, totalPendingApprovedPlayer: Object.values(response.Data) }));
    } catch (error) {
      console.log(error);
    }
  };
  const findTotalPlayerFollowedByParticipantFeeAndEvent = async () => {
    try {
      const response = await ReportingAPI.getTotalPlayerFollowedByParticipantFeeAndEvent(selectedClub.clubId, selectedEvent.event3);
      setChartData(prev => ({ ...prev, totalPlayerByFee: response.Data }));
    } catch (error) {
      console.log(error);
    }
  };
  const findTotalParticipantFeeByType = async () => {
    try {
      const response = await ReportingAPI.getTotalParticipantFeeByType(selectedEvent.event2, selectedClub.clubId);
      setChartData(prev => ({ ...prev, totalTypeOfParticipantFee: response.Data }));
    } catch (error) {
      console.log(error);
    }
  };
  const findUpcomingSchedules = async () => {
    try {
      if (isClubOwner(userInfo) || isClubStaff(userInfo)) {
        const response = await ReportingAPI.getUpcomigSchedulesFromClub(selectedClub.clubId);
        setScheduleData(prev => ({ ...prev, upcoming: response.Data }))
      } else {
        const response = await ReportingAPI.getUpcomigSchedulesByUser(selectedClub.clubId, userInfo.userId);
        setScheduleData(prev => ({ ...prev, upcoming: response.Data }))
      }
    } catch (error) {
      console.log(error);
    }
  };
  const findPastSchedules = async () => {
    try {
      if (isClubOwner(userInfo) || isClubStaff(userInfo)) {
        const response = await ReportingAPI.getPastSchedulesFromClub(selectedClub.clubId);
        setScheduleData(prev => ({ ...prev, past: response.Data }));
      } else {
        const response = await ReportingAPI.getPastSchedulesByUser(selectedClub.clubId, userInfo.userId);
        setScheduleData(prev => ({ ...prev, past: response.Data }));
      }
    } catch (error) {
      console.log(error);
    }
  };
  const findEventList = async () => {
    try {
      const response = await EventAPI.getAllEventForListOptions(selectedClub.clubId);
      setEventList(response.Data);
      if (response.Data.length != 0) {
        setSelectedEvent({ event1: response?.Data[0]?.eventId, event2: response?.Data[0]?.eventId, event3: response?.Data[0]?.eventId });
      }
    } catch (error) {
      console.log(error);
    }
  };
  const findAllPrivileges = async () => {
    try {
      setIsLoading(true);
      const reqObj = {
        userId: userInfo.userId,
        featureName: Object.keys(Privileges)[18]
      }
      const response = await PrivilegeAPI.getAllPrivilegesByFeature(reqObj);
      setPrivileges(response.Data);
      return response;

    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleFetchRSVPIsEnable = async () => {
    try {
      const response = await CalendarAPI.getCalendarConfigRsvp(selectedClub.clubId);
      setIsRSVPEnable(response.Data);
    } catch (error) {
      console.log(error);
    }
  };
  const handleRSVPRequestStatus = async (request, status) => {
    try {
      setIsLoading(true)
      const response = await CoachSchedulerAPI.putUpdateRSVPRequestStatus({
        scheduleId: request.scheduleId,
        rsvpId: request.rsvpId,
        userId: userInfo.userId,
        clubId: selectedClub.clubId,
        status: status
      })
      setIsRefresh(true);
      dispatch(rootAction.setWarningMessage({ id: Date.now(), type: response.Data?.type, content: response.Data?.message ?? 'Something went wrong' }))
    } catch (error) {
      console.log(error);
    }finally{
      setLoadingState(false);
    }
  };
  useEffect(() => {
    if (selectedClub?.clubId && selectedEvent.event1 != '') {
      findTotalPendingAndApprovedPlayer();
    }
  }, [selectedClub?.clubId, selectedEvent.event1])

  useEffect(() => {
    if (selectedClub?.clubId && selectedEvent.event2 != '') {
      findTotalParticipantFeeByType();
    }
  }, [selectedClub?.clubId, selectedEvent.event2])

  useEffect(() => {
    if (selectedClub?.clubId && selectedEvent.event3 != '') {
      findTotalPlayerFollowedByParticipantFeeAndEvent();
    }
  }, [selectedClub?.clubId, selectedEvent.event3])

  useEffect(() => {
    if (selectedClub?.clubId) {
      findAllPrivileges().then((data) => {
        findTotalRevenueSplitByMonth(data.Data);
        findTotalRevenueFromClub(data.Data);
        findTotalPlayerFollowedByEvent();
      })
    }
  }, [selectedClub?.clubId])
  useEffect(() => {
    if (selectedClub?.clubId) {
      findEventList();
      findTotalPlayerFromClub();
      findTotalMemberFromClub();
      findTotalEventFromClub();
    }
  }, [selectedClub?.clubId])


  useEffect(() => {
    if (selectedClub?.clubId) {
      findUpcomingSchedules();
      findPastSchedules();
      fetchAllRSVPRequests()
      handleFetchRSVPIsEnable();
    }
    isRefresh && setIsRefresh(false);
  }, [selectedClub?.clubId, isRefresh])


  function generateHexColors(count) {
    const colors = [];

    for (let i = 0; i < count; i++) {
      const r = Math.floor(150 + Math.random() * 100); // Red: 150–250
      const g = Math.floor(200 + Math.random() * 55);  // Green: 200–255
      const b = Math.floor(Math.random() * 100);       // Blue: 0–100

      const hex = `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
      colors.push(hex);
    }

    return colors;
  }

  return (
    <div className={styles['main_dashboard_con']}>
      {isLOading && <Loader />}
      <div className={styles['dashboard_data_card_list']}>
        {(isClubOwner(userInfo) || isClubStaff(userInfo)) &&
          <>
            <DashboardDataCard label="Club Member" data={Object.values(countingData.totalMember)} Icon={MdGroups} />
            <DashboardDataCard label="Total Player" data={Object.values(countingData.totalPlayer)} Icon={MdGroups} />
          </>
        }
        <DashboardDataCard label={isShowTransactionData ? "Realized Revenue" : "Total Paid"}
          data={Object.values(countingData.totalRevenue)} Icon={CgDollar} />
        {(isClubOwner(userInfo) || isClubStaff(userInfo)) &&
          <DashboardDataCard label={"Pending Revenue"} data={Object.values(countingData.pendingRevenue)} Icon={CgDollar} />}
        <DashboardDataCard2 label={(isClubOwner(userInfo) || isClubStaff(userInfo)) ? "Total Event" : "Total Events Joined"} data={Object.values(countingData.totalEvent)} Icon={MdOutlineEventNote} />
      </div>
      <div className={styles['dashboard_part_2']}>
        <div className={styles['dashboard_part_2_sec_1']}>
          <RevenueLineChart label={monthLabel} dataLabel={isShowTransactionData ? "Revenue" : "Money Spent"} data={chartData.totalRevenueSplitByMonth} />
        </div>
        {chartData.eventTotalPlayer.length !== 0 &&
          <div className={styles['dashboard_part_2_sec_1']}>
            <RevenueLineChart label={chartData.eventTotalPlayer.map(d => d.eventName)} dataLabel={"Total Player By Roster"} data={chartData.eventTotalPlayer.map(d => Number(d.totalPlayer))} />
          </div>}
      </div>
      <div className={styles['dashboard_bar_chart']}>
      {(isClubOwner(userInfo) || isClubStaff(userInfo)) &&
        <div className={ !isRSVPEnable ? `${styles['dashboard_bar_chart_content']} ${styles['full_screen']}` : styles['dashboard_bar_chart_content'] }>
          <div className={styles['dashboard_part_3_sec_2_p1']}>
            <FormControl data-testid="game-dropdown"
              className='sm_roster_select_season_input'
              fullWidth>
              <InputLabel sx={{
                top: '-8px', '&.Mui-focused': {
                  top: '0px',
                },
                '&.MuiInputLabel-shrink': {
                  top: '0px',
                },
                transition: 'top 0.2s ease'
              }} id="demo-simple-select-autowidth-label">Event</InputLabel>
              <Select
                sx={{ width: '200px' }}
                labelId="demo-simple-select-autowidth-label"
                id="demo-simple-select-autowidth"
                value={selectedEvent.event3 || ''}
                onChange={(event) => setSelectedEvent(prev => ({ ...prev, event3: event.target.value }))}
                name='relation'
                label="Event"
                size='small'
              >
                {eventList?.map((item, index) => (
                  <MenuItem key={index} value={item.eventId}>
                    {item.eventName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <EventFeeBarChart barChartData={chartData.totalPlayerByFee} />
        </div>}
        {isRSVPEnable &&
          <div className={styles['dashboard_part_2_sec_2']}>
            <h3>RSVP Requests</h3>
            {rsvpRequests?.length != 0 ?
              <div className={styles['rsvp_request_list']}>
                {
                  rsvpRequests?.map((r) =>
                    <RSVPCard key={r?.rsvpId} handleRSVPRequestStatus={handleRSVPRequestStatus} request={r} />
                  )
                }
              </div>
              :
              <div className={styles['no_rsvp_found']}>
                <p> There are no RSVP requests at the moment.</p>
              </div>}
          </div>}
      </div>
      <div className={styles['dashboard_part_4']}>
        <div className={styles['dashboard_part_4_sec_1']}>
          <h3>Upcoming Schedule</h3>
          {scheduleData?.upcoming?.length != 0 ?
            <div className={styles['upcoming_schedule_container']}>
              {
                scheduleData.upcoming.map((data) =>
                  <ScheduleCard key={data.scheduleId} schedule={data} />
                )
              }
            </div>
            :
            <div className={styles['no_schedule_found']}>
              <p>No upcoming schedule found</p>
            </div>}
        </div>
        <div className={styles['dashboard_part_4_sec_2']}>
          <h3>Past Schedule</h3>
          {scheduleData?.past?.length != 0 ?
            <div className={styles['upcoming_schedule_container']}>
              {
                scheduleData.past.map((data) =>
                  <ScheduleCard key={data.scheduleId} schedule={data} />
                )
              }
            </div>
            :
            <div className={styles['no_schedule_found']}>
              <p>No past schedule found</p>
            </div>}
        </div>
      </div>
      {(eventList?.length != 0 && (isClubOwner(userInfo) || isClubStaff(userInfo))) &&
        <div className={styles['dashboard_part_3']}>
          <div className={styles['dashboard_part_3_sec_1']}>
            <div className={styles['dashboard_part_3_sec_2_p1']}>
              <h3>Participant Fee By Event</h3>
              <FormControl data-testid="game-dropdown"
                className='sm_roster_select_season_input'
                fullWidth>
                <InputLabel sx={{
                  top: '-8px', '&.Mui-focused': {
                    top: '0px',
                  },
                  '&.MuiInputLabel-shrink': {
                    top: '0px',
                  },
                  transition: 'top 0.2s ease'
                }} id="demo-simple-select-autowidth-label">Event</InputLabel>
                <Select
                  sx={{ width: '200px' }}
                  labelId="demo-simple-select-autowidth-label"
                  id="demo-simple-select-autowidth"
                  value={selectedEvent.event2 || ''}
                  onChange={(event) => setSelectedEvent(prev => ({ ...prev, event2: event.target.value }))}
                  name='relation'
                  label="Event"
                  size='small'
                >
                  {eventList?.map((item, index) => (
                    <MenuItem key={index} value={item.eventId}>
                      {item.eventName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <PieChart data={Object.values(chartData.totalTypeOfParticipantFee)}
              labels={Object.keys(chartData.totalTypeOfParticipantFee)}
              backgroundColors={generateHexColors(Object.keys(chartData.totalTypeOfParticipantFee).length)}
            />
          </div>
          <div className={styles['dashboard_part_3_sec_2']}>
            <div className={styles['dashboard_part_3_sec_2_p1']}>
              <h3>Player Status By Event</h3>
              <FormControl data-testid="game-dropdown"
                className='sm_roster_select_season_input'
                fullWidth>
                <InputLabel sx={{
                  top: '-8px', '&.Mui-focused': {
                    top: '0px',
                  },
                  '&.MuiInputLabel-shrink': {
                    top: '0px',
                  },
                  transition: 'top 0.2s ease'
                }} id="demo-simple-select-autowidth-label">Event</InputLabel>
                <Select
                  sx={{ width: '200px' }}
                  labelId="demo-simple-select-autowidth-label"
                  id="demo-simple-select-autowidth"
                  value={selectedEvent.event1 || ''}
                  onChange={(event) => setSelectedEvent(prev => ({ ...prev, event1: event.target.value }))}
                  name='relation'
                  label="Event"
                  size='small'
                >
                  {eventList?.map((item, index) => (
                    <MenuItem key={index} value={item.eventId}>
                      {item.eventName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <PieChart
              data={chartData.totalPendingApprovedPlayer}
              labels={['Approved', 'Pending']}
              backgroundColors={generateHexColors(Object.keys(chartData.totalPendingApprovedPlayer).length)}
            />
          </div>
        </div>}
    </div>
  )
}

export default Dashboard
